/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/pow.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the value of `base` raised to the power of `exponent`.',
  examples: [
    'ROW base = 2.0, exponent = 2\n| EVAL result = POW(base, exponent)',
    'ROW base = 4, exponent = 0.5\n| EVAL s = POW(base, exponent)',
  ],
  note: 'It is still possible to overflow a double result here; in that case, null will be returned.',
  params: {
    base: 'Numeric expression for the base. If `null`, the function returns `null`.',
    exponent: 'Numeric expression for the exponent. If `null`, the function returns `null`.',
  },
};

export default docs;
